import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function HomeCTA() {
  return (
    <section className="bg-blue-700 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white font-['Outfit'] mb-6">
          Ready to Transform Your Business?
        </h2>
        <p className="text-lg text-blue-100 mb-8 font-['Plus_Jakarta_Sans']">
          Let's discuss how Nidus Technologies can help you achieve your technology goals.
        </p>
        <Link to="/contact">
          <Button 
            className="bg-white text-blue-700 hover:bg-slate-100 rounded-none px-8 py-6 text-base font-medium"
          >
            Get Started Today
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </Link>
      </div>
    </section>
  );
}
